import { render, staticRenderFns } from "./FaqDialog.vue?vue&type=template&id=60ab9888&"
import script from "./FaqDialog.vue?vue&type=script&lang=js&"
export * from "./FaqDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports